/* Copyright 2022- Martin Kufner */
// import "@qb-gettext-js/gettext"

const tagNames = "A ABBR ACRONYM ADDRESS APPLET AREA ARTICLE ASIDE AUDIO B BASE BASEFONT BDI BDO BIG BLOCKQUOTE BODY BR BUTTON CANVAS CAPTION CENTER CITE CODE COL COLGROUP DATA DATALIST DD DEL DETAILS DFN DIALOG DIR DIV DL DT EM EMBED FIELDSET FIGCAPTION FIGURE FONT FOOTER FORM FRAME FRAMESET HEAD HEADER HGROUP H1 HR HTML I IFRAME IMG INPUT INS KBD KEYGEN LABEL LEGEND LI LINK MAIN MAP MARK MENU MENUITEM META METER NAV NOFRAMES NOSCRIPT OBJECT OL OPTGROUP OPTION OUTPUT P PARAM PICTURE PRE PROGRESS Q RP RT RUBY S SAMP SCRIPT SECTION SELECT SLOT SMALL SOURCE SPAN STRIKE STRONG STYLE SUB SUMMARY SUP SVG TABLE TBODY TD TEMPLATE TEXTAREA TFOOT TH THEAD TIME TITLE TR TRACK TT U UL VAR VIDEO WBR".split(/\s+/).filter(t => t);

const AppendableObjectRE = /^(Text|DocumentFragment|CDATASection|String)$/;
const AppendableRE = /^(string|number|boolean)$/;

const setObserver = function (value, target = this.parentElement) {
    if(value[0] instanceof HTMLElement) target = value.shift();
    let [callback, options] = value;
    if(!callback) callback = target.observer
    else if(typeof callback === "string") callback = target[`observer_${callback}`];
    if(typeof callback == "function") {
        const observer = new MutationObserver((m, o) => callback.call(target, m, o));
        observer.observe(this, options || {childList: true});
        return observer;
    }

    const klass = target.constructor.name;
    let msg = `cT Observer: handler not found in ${klass}: observer(mutation){}`;
    if(value[0]) msg += `observer_${value[0]}(mutation){}`;
    const exc = Object.assign(new Error(msg), {node: this, target});
    Reflect.defineProperty(exc, "stack", {
        value: exc.stack.replace(/\n\s+at.*?at cT[^\n]+/s, '')
    })
    console.info(exc);

}

const setIntersection = function (value, target = this.parentElement) {

}

const registerLongClick = function (target) {
    if('longClick' in target) return;
    target.longClick = null;
    target.addEventListener('mousedown', evt => {
        target.addEventListener('mouseup', this, {once: true});
        target.longClick = setTimeout(() => {
            target.dispatchEvent(new CustomEvent('longclick'));
            target.longClick = null;
        }, 500);
    }, {capture: true});

    target.addEventListener('mouseup', () => clearTimeout(target.longClick), {capture: true});

    target.addEventListener('click', evt=>{
        if(target.longClick) return target.longClick = null;
        evt.preventDefault();
        evt.stopImmediatePropagation()
    }, {capture:true});
}

const setEvents = function (value, target = this.parentElement || this) {
    if(typeof value === "string") {
        try {
            JSON.parse(value)
        }
        catch(e) {
            value = JSON.stringify([value]);
        }
        this.setAttribute("events", value);
        return;
    }
    const events = [];
    if(value === null || value === undefined) return;
    else if(value instanceof Array) for(const v of value) {
        if(v instanceof Array) events.push(v.slice(0, 2));
        else if(v instanceof HTMLElement) target = v;
        else if(typeof v === "object") events.push(...Object.entries(v));
        else if(typeof v === "string") events.push(...v.split(/\s+/).map(v => [v]));
    }
    else if(typeof value === "object") {
        const {target: _target, ...values} = value;
        if(_target) target = _target;
        events.push(...Object.entries(values))
    }
    for(let [e, fn] of events) {
        if(e === "longclick") registerLongClick(this);
        const options = {};
        let active;
        [e, active] = e.split("_");
        switch(e) {
            case "touchstart":
            case "touchmove":
            case "touchend":
            case "wheel":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseenter":
            case "mouseleave":
            case "mouseover":
            case "mouseout":
                options.passive = active !== 'active';
        }

        if(typeof fn === "function") {
            this.addEventListener(e, fn.bind(target), options);
        }
        else if(target.handleEvent) {
            if(!this.handleEventTargets) Object.defineProperty(this, 'handleEventTargets', {value: {}});
            this.handleEventTargets[e] = fn || e;
            this.addEventListener(e, target, options);
        }
        else {
            const klass = target.constructor.name;
            let msg = `cT Event: handleEvent for ${e} not found in ${klass}`;
            const exc = Object.assign(new Error(msg), {node: this, target});
            Reflect.defineProperty(exc, "stack", {
                value: exc.stack.replace(/\n\s+at.*?at cT[^\n]+/s, '')
            })
            console.info(exc);
        }
    }
}

const synonyms = {
    html: "innerHTML",
    maxlength: 'maxLength'
}


export const cT = function (node, ...args) {
    if(typeof node === 'string') {
        if(/[<\s.]/.test(node)) {
            const frag = document.createElement('div');
            const [_, nodeName, attrs, innerHTML] = node.match(/^(\S+)\s?([^<]+)?(.*)$/);
            if(/\./.test(nodeName)) {
                const [_nodeName, ...classNames] = nodeName.trim().split('.')
                frag.innerHTML = `<${_nodeName} ${attrs || ''}>${innerHTML || ''}`;
                node = frag.firstElementChild;
                node.classList.add(...classNames);
            }
            else {
                frag.innerHTML = `<${nodeName} ${attrs}>${innerHTML}`;
                node = frag.firstElementChild;
            }
        }
        else node = document.createElement(node);
    }
    if(!args.length) return node;
    const events = [], observe = [], intersect = [];
    let target, findBy, connect;
    for(const arg of args.flat()) {
        if(arg === null || arg === undefined) continue;
        else if(typeof arg === 'object') {
            if(arg instanceof HTMLElement || AppendableObjectRE.test(args.constructor.name)) node.append(arg);
            else {
                for(let k in arg) {
                    if(k in synonyms) k = synonyms[k];
                    switch(k) {
                        case "findBy":
                            findBy = arg.findBy;
                            continue;
                        case "data":
                        case "dataset":
                            for(const [p, v] of Object.entries(arg[k])) v === undefined || v === null || (node.dataset[p] = v);
                            continue;
                        case 'intersect':
                            intersect.push(arg.intersect);
                            continue;
                        case 'observe':
                            observe.push(arg.observe);
                            continue;
                        case 'events':
                            events.push(arg.events);
                            continue;
                        case 'class':
                        case 'className':
                            const classNames = arg[k]?.split(/\s+/).filter(n => n);
                            if(classNames?.length) node.classList.add(...classNames);
                            continue;
                        case 'classList':
                            node.classList.add(...arg.classList);
                            continue;
                        case 'itemid':
                        case 'itemtype':
                            if(node.__lookupSetter__(k)) break;
                            node.setAttribute('itemscope', '');
                        case 'name':
                            if(node.__lookupSetter__("name")) break;
                        case 'for':
                        case 'form':
                        case 'required':
                        case 'pattern':
                        case 'tabindex':
                            node.setAttribute(k, arg[k]);
                            continue;
                        case 'disabled':
                            if(arg[k] !== false) node.setAttribute(k, "");
                            else node.removeAttribute(k);
                            continue;
                        case "aria":
                            Object.entries(arg.aria).forEach(([k,v])=>{
                                if(Object.present(v)) node.setAttribute(`aria-${k}`, v);
                                else node.removeAttribute(k);
                            });
                            continue;
                        case 'attributes':
                            node.setAttributes(arg.attributes);
                            continue;
                        case 'customProperties':
                            node.setCustomProperties(arg.customProperties);
                            continue;
                        case 'afterbegin':
                        case 'beforeend':
                            if(arg[k] instanceof ShadowRoot) {
                                target = arg[k].host;
                                connect = [k, arg[k]];
                                continue;
                            }
                        case 'afterend':
                        case 'beforebegin':
                            connect = [k, target = arg[k]];
                            continue;
                        case 'replace':
                            arg.replace.replaceWith(node);
                            continue;
                    }
                    const setter = node.__lookupSetter__(k);
                    if(setter) setter.call(node, arg[k]);
                    else if(!node.__lookupGetter__(k) && typeof node[k] === 'function') node[k][arg[k] instanceof Array ? 'apply' : 'call'](node, arg[k]);
                    else console.trace(`cT warning: not found '${k}' in`, node, node.constructor.name, args[k]);
                }
            }
        }
        else if(AppendableRE.test(typeof arg)) node.append(arg.toString());
        else throw `cT warning: Can't add ${typeof arg}`;
    }
    if(connect && connect[1]) {
        const [position, ref] = connect;
        if(findBy) {
            let n;
            switch(position) {
                case 'afterbegin':
                case 'beforeend':
                    n = ref.querySelector(findBy);
                    if(n) return n;
                    break;
                default:
                    n = k === 'beforebegin' ? ref.previousElementSibling : ref.nextElementSibling;
                    if(n?.matches(findBy)) return n;
                    break;
            }
        }
        if(position === 'afterbegin') ref.prepend(node);
        else if(position === 'beforeend') ref.append(node);
        else ref.insertAdjacentElement(position, node);
    }
    for(let e of events) setEvents.call(node, e, target);
    for(const o of observe) setObserver.call(node, o, target);
    for(const i of intersect) setIntersection.call(node, i, target);
    return node;
}

cT.register = function (options) {
    let {attach, prefix, postfix, overwrite, tags} = Object.assign({
        attach: self,
        prefix: '',
        postfix: '',
        overwrite: false,
        tags: true
    }, options);
    Reflect.defineProperty(attach, 'cT', {value: cT});
    if(tags) {
        const convert = tags === "downcase" ? "toLowerCase" : "toUpperCase";
        tagNames.forEach(tagName => {
            tagName = tagName[convert]();
            const regName = `${prefix}${tagName}${postfix}`;
            if(regName in attach && !overwrite) console.warn(`Not registering ${regName} exists:`, attach[regName]);
            else Reflect.defineProperty(attach, regName, {value: cT.bind(null, tagName)});
        });
    }
    cT.register = () => {};
}


Object.defineProperties(cT, {
    ...Object.fromEntries(tagNames.map(tag => [tag, {value: cT.bind(null, tag)}])),
    parse: {
        value(node, target) {
            node.querySelectorAll("[events]").forEach(n => {
                const events = JSON.parse(n.getAttribute('events'));
                n.removeAttribute('events');
                if(events instanceof Array) events.unshift(target);
                else events.target = target;
                setEvents.call(n, events);
            });
        }
    },
    setEvents: {
        value(node, events) {
            setEvents.call(node, events);
        }
    },
    sanitizeName: {
        value(name) {
            return name?.replace(/(-(.))|(\[)|]/g, (...m) => m[3] ? "_" : m[2]?.toUpperCase() || "");
        }
    },
    sortIn: {
        value(container, node) {
            container.append(node);
            this.sort(container);
            return node;
        }
    },
    sort: {
        value(container, sort = 'sortIndex') {
            if(container.sortingInProgress) return container;
            const children = container.children;
            window.requestAnimationFrame(() => {
                const sorted = [...children].sort((lo, hi) => typeof sort === 'function' ? sort(lo) - sort(hi) : lo[sort] - hi[sort]);
                for(const i in sorted) {
                    const n = sorted[i], c = children[i];
                    if(c !== n) c.before(n);
                }
                delete container.sortingInProgress;
            });
            container.sortingInProgress = true;
            return container;
        }
    },
    Fragment: {
        value(...args) {
            const fragment = document.createDocumentFragment(),
                node = document.createElement('div');
            for(const arg in args) {
                if(typeof arg === 'string') {
                    node.innerHTML = arg;
                    fragment.append(node.firstElementChild);
                }
                else if(AppendableObjectRE.test(arg.constructor.name)) fragment.append(arg);
            }
            return fragment;
        }
    },
    eventTarget: {
        value(target, root) {
            console.trace('implement cT#event target', {target, root})
        }
    }
});

Object.defineProperties(HTMLSelectElement.prototype, {
    values: {
        get() {
            return [...this.selectedOptions].map(n => n.value)
        },
        set(values) {
            if (values instanceof Array) this.multiple = true;
            values = [values].flat().filter(v => v);
            [...this.options].forEach(n => n.selected = values.includes(n.value));
        }
    }
});

const RADIO_PROPERTIES = {
    deselectable: {
        get() { return this.hasAttribute("deselectable") },
        set(value) {
            if(value) this.setAttribute("deselectable", "");
            else this.removeAttribute("deselectable");
        }
    },
    changed: {
        get() { return this._checked !== this.checked }
    },
    handleEvent: {
        value(evt) {
            // console.log(evt);

            switch(evt.type) {
                case "mousedown":
                    if(!this.deselectable) return;
                    this._checked = !this.checked;
                    if(this._checked === true) return;
                    break;
                case "keydown":
                    if (!this.deselectable || evt.code !== 'Space') return;
                    this._checked = !this.checked;
                    if(this._checked === true) return;
                    break;
                case "change":
                    break;
                default:
                    return;
            }
            if(this._checked !== this.checked) {
                this.checked = this._checked;
            }
            if(evt.type !== "change") return;
            this.dispatchEvent(new Event('toggle', {bubbles: true}));
            if(!this.checked) return;
            for(const n of document.getElementsByName(this.name)) {
                if(n === this) continue;
                return n.dispatchEvent(new Event('toggle', {bubbles: true}));
            }
        }
    }
};


Object.defineProperties(cT, {
    // Fragment: {
    //     value(...args) {
    //         return ContentTag.Fragment(...args)
    //     }
    // },
    // update: {
    //     value(...args) {
    //         return ContentTag.update(...args)
    //     }
    // },
    // eventTarget: {
    //     value(target, node) {
    //         if (!node) node = target;
    //         const nodes = [...node.querySelectorAll("[events]")];
    //         if (node.matches && node.matches("[events]")) nodes.unshift(node);
    //         nodes.forEach(node => new ContentTag(node).eventTarget = target);
    //         return node;
    //     }
    // },
    Slot: {
        value(slot, ...args) {
            return this.SPAN({slot}, ...args)
        }
    },
    LinkTo: {
        value(text, href, ...options) {
            return this.A(text, {href: href}, ...options)
        }
    },
    Input: {
        value(...args) {
            return this.INPUT({autocomplete: "off"}, ...args)
        }
    },
    TextField: {
        value(name, value, ...options) {
            return this.INPUT({
                type: 'text',
                value: value,
                name: name
            }, {autocomplete: "off"}, ...options);

        }
    },


    CheckBox: {
        value(name, value, checked, option, ...options) {
            if (option && option.constructor.name !== 'Object') {
                options.unshift(option);
                option = undefined;
            }
            if (typeof checked !== 'boolean') checked = value === checked;
            const input = this('input', {type: "checkbox", value, name, checked, autocomplete: "off"}, option);
            if (options.length === 0) return input;
            const label = this.LABEL(input, ...options);
            if (input.id) label.htmlFor = input.id;
            return label;
        }
    },


    RadioButton: {
        value(name, value, checked, option, ...options) {
            if (option && option.constructor.name !== 'Object') {
                options.unshift(option);
                option = undefined;
            }
            if (typeof checked !== 'boolean') checked = value === checked;
            const input = this('input', {type: "radio", value, name, checked, autocomplete: "off"});
            Object.defineProperties(input, RADIO_PROPERTIES);
            input.addEventListener("mousedown", input, { capture: true });
            input.addEventListener("keydown", input, { capture: true });
            input.addEventListener("change", input, { capture: true });
            cT(input, option);
            if (options.length === 0) return input;
            const label = this.LABEL(input, ...options);
            if (input.id) label.htmlFor = input.id;
            return label;
        }
    },
    HiddenField: {
        value(name, value, ...options) {
            return this('input', {
                type: 'hidden',
                value: value,
                name: name
            }, ...options)
        }
    },
    OptGroup: {
        value(option, ...options) {
            if (typeof option === "string") option = {label: option};
            return this.OPTGROUP(option, this.Options(...options));
        }
    },
    Options: {
        value(...options) {
            const node = new DocumentFragment();
            options.flat().forEach(option => {
                if(/^HTMLOpt/.test(option.constructor.name)) node.append(option);
                else if(option instanceof Object || typeof options === 'string') node.append(this.OPTION(option));
            });
            return node;
        }
    },
    Select: {
        value(name, option, ...options) {
            let values;
            if(option instanceof Array) {
                values = option;
                option = undefined;
            }
            else if(typeof option === 'object') {
                values = option.value || option.values;
                delete option.value;
                delete option.values;
                if ("prompt" in option) {
                    if (option.prompt)
                        options.unshift({
                            value: "",
                            selected: values === undefined,
                            textContent: typeof option.prompt === "string" ? option.prompt : ""
                        });
                    delete option.prompt;
                }
            }
            else {
                options.unshift(option);
                option = undefined;
            }
            const node = this.SELECT({name}, option, {autocomplete: "off", values}, this.Options(...options));
            return node;
        }
    },
    // SendForm: {
    //     value(action, method, params) {
    //         const ce = (tagName, options) => Object.assign(document.createElement(tagName), options);
    //         const form = ce("form", {action, method});
    //         form.append(...Object.entries(params).map(([name, value]) => ce("input", {type: "hidden", name, value})));
    //         document.body.append(form);
    //         form.submit();
    //         form.remove();
    //     }
    // },

    // _: {
    //     value(text, ...options) {
    //         const node = cT("qb-gettext");
    //         node.content = text;
    //         return node;
    //     }
    // },
});



